import { axiosInstance } from "lib/axios";
import { searchAPI } from "services/apis.service";

export const customSummarize = async (summaryText) => {
  const data = await axiosInstance.post(
    searchAPI.getSummary,
    {
      summary: summaryText,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};
